import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { VodafoneGeneralReport, VodafoneGeneralReportRequest } from '../models/model'

export class GetVodafoneGeneralReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/getVodafoneGeneralReport',
      requesterInfo,
    })
  }

  public async getVodafoneGeneralReport(req: VodafoneGeneralReportRequest): Promise<VodafoneGeneralReport[]> {
    return await this.postAsync<VodafoneGeneralReport[]>(req)
  }
}
